module.exports = __webpack_public_path__ + "img/4.bcbd24a4.png";